<template>
	<div class="status-table">
		<el-table :data="order_status" class="order_status_table" :default-sort="{prop: '', order: ''}"
			empty-text="暫無數據"
			@sort-change="handleTableSort" 	@selection-change="handleSelectionChange" tooltip-effect="dark">
			<el-table-column
			    type="selection"
			    width="44">
			</el-table-column>
			<!-- 订单号 -->
			<el-table-column :label="$t('message.costatus.table1')" prop="order_sn" min-width="160" align="center"
				sortable="custom" show-overflow-tooltip>
				<template v-slot="{row}">
					<el-button type="text" size="mini" class="order_status_table_sn" @click="getDetail(row.order_id)">
						{{row.order_sn}}
					</el-button>
				</template>
			</el-table-column>
			<!-- 日期 -->
			<el-table-column :label="$t('message.costatus.table2')" prop="createtime" min-width="100" align="center"
				sortable="custom">
			</el-table-column>
			<!-- 金额 -->
			<el-table-column :label="$t('message.costatus.table3')" prop="order_amount" min-width="130" align="center"
				sortable="custom" v-if="powerPrice">
				<template v-slot="{row}">
					<span>{{currency}}</span>
					<span class="order_status_table_price">{{row.order_amount}}</span>
				</template>
			</el-table-column>
			<!-- 操作用户 -->
			<el-table-column :label="$t('message.costatus.table4')" prop="username" min-width="130" align="center"
				sortable="custom" show-overflow-tooltip v-if="!power.includes(111)">
			</el-table-column>
			<!-- 部门 -->
			<el-table-column :label="$t('message.costatus.table5')" prop="departmentname"
				v-if="power && power.indexOf(111)<0" min-width="130" align="center" sortable="custom"
				show-overflow-tooltip>
			</el-table-column>
			<!-- 子公司/分行 -->
			<slot name="branch">
			</slot>
			<!-- 状态 -->
			<el-table-column :label="$t('message.costatus.table6')" prop="status" align="center" sortable="custom">
				<template v-slot="{row}">
					<div  v-if="row.pay_status == 40">
						已退款
					</div>
					<div v-else-if="row.status!=null && row.order_status==0">
						{{{val:row.status,lang:$t("message.costatus")} | status}}
					</div>
					<div v-else-if="row.pay_status">
						{{{val:row.pay_status,lang:$t("message.costatus")} | pay_status}}
					</div>
					<div v-else>
						{{{val:row.order_status,lang:$t("message.costatus")} | orstatus}}
					</div>
				</template>
			</el-table-column>
			<!-- 部分支付金額 -->
			<el-table-column v-if="type==1" :label="$t('message.costatus.table7')" prop="part_pay_amount"
				min-width="130">
			</el-table-column>
		</el-table>
		<div class="pagination-btn">
			<el-button @click="handleExport" type="primary">
				全部導出
			</el-button>
		</div>
		<table-pagination :current-page="currentPage" :page-count="pageCount" @current-change="handleCurrent">
		</table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination @current-change="handleCurrent" :current-page.sync="currentPage2" :page-size="page.per_page"
				layout="prev, pager, next, jumper" :total="page.total" background>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations
	} from 'vuex'
	import {
		OrderFilters
	} from '@/utils/orderFilters.js'
	import {
		tableSortHandle
	} from "@/utils/publicMethod.js";

	export default {
		mixins: [OrderFilters, tableSortHandle],
		props: {
			"getDetail": {
				type: Function
			},
			"type": {
				type: String
			}
		},
		computed: {
			...mapState({
				order_status: state => state.order.order_status,
				currency: state => state.currency,
				power: state => state.user.power,
				page: state => state.user.page
			}),
			...mapGetters([
				'powerPrice',
			])
		},
		data() {
			return {
				currentPage2: 0,
			}
		},
		watch: {
			currentPage() {
				this.currentPage2 = this.currentPage
			}
		},
		methods: {
			...mapMutations([
				"handleDialog"
			]),
			handleExport() {
			    this.$emit('handle-export')
			},
		},
	}
</script>

<style scoped>
	.pagination-btn {
		margin: 20px;
	}
	.status-table {
		background-color: #fff;
	}

	/* 订单号 */
	.order_status_table_sn {
		width: 100%;
		/* text-align: left; */
		text-overflow: ellipsis;
		overflow: hidden;
	}

	/* 订单金额 */
	.order_status_table_price {
		margin-left: 5px;
		font-weight: bold;
		color: #FF6700
	}

	/* 滚动条 */
	/deep/ .el-table__body-wrapper::-webkit-scrollbar {
		width: 5px;
		height: 10px !important;
		background-color: #ddd;
		
	}

	.order_status_table>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
		background-color:#fd641f;
		border-radius: 5px;
	}
</style>
